import * as React from 'react';
import * as Sentry from '@sentry/browser';

if (process.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://dfc19e25771a4aad8a19c2f02097fc48@sentry.kreditpintar.com/48',
    environment: 'hybrid',
  });
}

export function sentryExceptionHandler (this: React.Component<{},{eventId?:string}> ,error: Error, errorInfo: React.ErrorInfo) {
  Sentry.withScope(scope => {
    scope.setExtras(errorInfo);
    const eventId = Sentry.captureException(error);
    this.setState({ eventId });
  });
};
